import { BarChart3, TrendingDown, TrendingUp, AlertCircle } from "lucide-react";

export const ColdEmailMetrics = () => {
  const volumeData = [
    { range: "1-25", openRate: "70%+", replyRate: "5-8%", risk: "Low", color: "text-success" },
    { range: "25-50", openRate: "65%", replyRate: "4-6%", risk: "Low", color: "text-success" },
    { range: "50-100", openRate: "55-60%", replyRate: "3-5%", risk: "Medium", color: "text-warning" },
    { range: "100-200", openRate: "40-50%", replyRate: "2-3%", risk: "High", color: "text-destructive" },
    { range: "200+", openRate: "20-30%", replyRate: "<1%", risk: "Critical", color: "text-destructive" },
  ];

  const spamTriggers = [
    { factor: "Sending volume", impact: 35, description: "Too many emails too fast" },
    { factor: "Content patterns", impact: 25, description: "Spammy words, links, formatting" },
    { factor: "Engagement signals", impact: 20, description: "Low opens, no replies, deletes" },
    { factor: "Domain reputation", impact: 15, description: "New or damaged sender score" },
    { factor: "Technical setup", impact: 5, description: "Missing SPF, DKIM, DMARC" },
  ];

  return (
    <section className="py-10 sm:py-12">
      <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-8 text-center">
        Volume vs. Performance Analysis
      </h2>
      
      <div className="bg-card rounded-2xl border border-border overflow-hidden mb-8">
        <div className="bg-muted/50 p-4 border-b border-border">
          <h3 className="font-semibold text-foreground flex items-center gap-2">
            <BarChart3 className="w-5 h-5 text-primary" />
            Daily Send Volume Impact
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/30">
              <tr>
                <th className="text-left text-sm font-medium text-muted-foreground px-4 py-3">Emails/Day</th>
                <th className="text-left text-sm font-medium text-muted-foreground px-4 py-3">Open Rate</th>
                <th className="text-left text-sm font-medium text-muted-foreground px-4 py-3">Reply Rate</th>
                <th className="text-left text-sm font-medium text-muted-foreground px-4 py-3">Risk Level</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {volumeData.map((row, index) => (
                <tr key={index} className="hover:bg-muted/20">
                  <td className="px-4 py-3 font-medium text-foreground">{row.range}</td>
                  <td className="px-4 py-3 text-muted-foreground">{row.openRate}</td>
                  <td className="px-4 py-3 text-muted-foreground">{row.replyRate}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
                      row.risk === "Low" ? "bg-success/10 text-success" :
                      row.risk === "Medium" ? "bg-warning/10 text-warning" :
                      "bg-destructive/10 text-destructive"
                    }`}>
                      {row.risk}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-card rounded-2xl border border-border p-6">
        <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
          <AlertCircle className="w-5 h-5 text-warning" />
          What Triggers Spam Filters (Weighted Impact)
        </h3>
        <div className="space-y-4">
          {spamTriggers.map((trigger, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-foreground">{trigger.factor}</span>
                <span className="text-sm text-muted-foreground">{trigger.impact}%</span>
              </div>
              <div className="h-2 bg-muted rounded-full overflow-hidden">
                <div 
                  className="h-full bg-primary rounded-full transition-all"
                  style={{ width: `${trigger.impact}%` }}
                />
              </div>
              <p className="text-xs text-muted-foreground mt-1">{trigger.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
